import {IRefundStatusJourney} from "./IRefundStatusJourney";
import {IRefundSuccess} from "./IRefundSuccess";

export default class RefundUtil {

    /**
     * If the user is entitled to perform a refund.
     *
     * @param refundStatus
     * @param dryRunResult
     */
    public canRefund(refundStatus: IRefundStatusJourney, dryRunResult: IRefundSuccess) {
        const retVal = dryRunResult && dryRunResult.refundValue > 0;
        console.log("canRefund based on dryRun", retVal);
        return retVal;
    }

    /**
     * Amount the customer will receive back via instant refund
     * (ticket value - admin fee)
     *
     * @param refundStatus
     * @param dryRunResult
     */
    public availableRefundValue(refundStatus: IRefundStatusJourney, dryRunResult: IRefundSuccess) {
        return (dryRunResult ? dryRunResult.refundValue : (refundStatus.ticketsRefundValue - refundStatus.adminFee));
    }

    /**
     * Amount the customer will receive back via replacement
     * (ticket value - admin fee)
     * 
     * @param refundStatus
     */
    public availableReplaceValue(refundStatus: IRefundStatusJourney) {
        return refundStatus.ticketsReplaceValue-refundStatus.adminFeeReplacement;
    }

    /**
     * Amount the customer can defer and use in a future change of journey
     * (ticket value - admin fee) if canDeferExchange set otherwise 0
     * 
     * @param refundStatus
     */
    public availableDeferValue(refundStatus: IRefundStatusJourney) {
        return refundStatus.canDeferExchange ? this.availableReplaceValue(refundStatus) : 0;
    }

    /**
     * If the user's refund is worth nothing.
     * 
     * @param refundStatus
     */
    public refundValueIsZero(refundStatus: IRefundStatusJourney, dryRunResult: IRefundSuccess) {
        return refundStatus && this.availableReplaceValue(refundStatus) <= 0 && this.availableRefundValue(refundStatus, dryRunResult) <= 0
            && (!dryRunResult || dryRunResult.refundValue <= 0);
    }

    public shouldRefundNoReplacement(refundStatus: IRefundStatusJourney, dryRunResult: IRefundSuccess) {
        // If TicketRefundValue >= TicketsReplaceValue they can immediately refund at the value
        // given with whatever admin fee we quote (if any).
        const ticketsRefundValue = (dryRunResult ? dryRunResult.refundValue : (refundStatus.ticketsRefundValue-refundStatus.adminFee));
        const retVal = ticketsRefundValue >= (refundStatus.ticketsReplaceValue - refundStatus.adminFeeReplacement);
        console.log("shouldRefundNoReplacement", retVal);
        return retVal;
    }


    constructor() {
    }
}
